import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

import AirDatepicker from "air-datepicker";
import localeEn from 'air-datepicker/locale/en';
import flatpickr from "flatpickr";

// Connects with data-controller="timesheets-config-form"
export default class extends Controller {

  connect() {
    this.initDatepickers();
  }

  // Initialize all existing date/time pickers
  initDatepickers() {
    const timepickers = document.querySelectorAll('.timepicker');
    const startTimeFields = document.querySelectorAll('.start-timepicker');
    const endTimeFields = document.querySelectorAll('.end-timepicker');

    const datepickers = document.querySelectorAll('.datepicker');
    
    timepickers.forEach(el => this.initTimepicker(el));
    datepickers.forEach(el => this.initDatepicker(el));
    startTimeFields.forEach(el => this.initTimepicker(el, "09:00")); // Default to 09:00
    endTimeFields.forEach(el => this.initTimepicker(el, "17:00")); // Default to 17:00
  }

  // initTimepicker(el) {
  //   if (!el._airDatepicker) {
  //     let defaultDate = new Date();
  //     let hasTime = false;
  //     if (el.value) {
  //       const [hours, minutes] = el.value.split(':').map(Number);
  //       if (!isNaN(hours) && !isNaN(minutes)) {
  //         defaultDate.setHours(hours);
  //         defaultDate.setMinutes(minutes);
  //         hasTime = true;
  //       }
  //     }
  //     const picker = new AirDatepicker(el, {
  //       onlyTimepicker: true,
  //       timepicker: true,
  //       dateFormat: 'HH:mm',
  //       minutesStep: 5,
  //       defaultDate: hasTime ? defaultDate : undefined,
  //       onSelect: ({date, formattedDate, datepicker}) => {
  //         datepicker.$el.value = formattedDate;
  //         datepicker.$el.dispatchEvent(new Event('change', { bubbles: true }));
  //       }
  //     });
  //     if (hasTime) {
  //       picker.selectDate(defaultDate, { updateTime: true });
  //     }
  //   }
  // }

  initTimepicker(el, defaultTime = "09:00") {
    if (!el._flatpickr) { // Ensure flatpickr is not already initialized
      // Set default time if the input is empty
      let timeValue = el.value || null; // Use the provided default time
      const [defaultHour, defaultMinute] = defaultTime.split(":").map(Number);
      flatpickr(el, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i", // 24-hour format
        defaultDate: timeValue,
        time_24hr: true,
        minuteIncrement: 5, // Step for minutes
        defaultHour: defaultHour,
        defaultMinute: defaultMinute,
        onChange: (selectedDates, dateStr) => {
          el.value = dateStr; // Update the input value
          el.dispatchEvent(new Event("change", { bubbles: true })); // Trigger a change event
        },
      });
    }
  }

  initDatepicker(el) {
    console.log("Initializing datepicker for:", el);
    if (!el._airDatepicker) {
      new AirDatepicker(el, {
        timepicker: false,
        dateFormat: 'dd/M/yyyy',
        locale: localeEn,
        onSelect: ({date, formattedDate, datepicker}) => {
          datepicker.$el.value = formattedDate;
          datepicker.$el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }


  get breakContainerTargets() {
    return $('[data-timesheets-config-form-target="breakContainer"]')
  }

  get breakTemplateTarget() {
    return $('[data-timesheets-config-form-target="breakTemplate"]')[0]
  }

  get overtimeRateContainerTarget() {
    return $('[data-timesheets-config-form-target="overtimeRateContainer"]')[0]
  }

  get overtimeRateTemplateTarget() {
    return $('[data-timesheets-config-form-target="overtimeRateTemplate"]')[0]
  }

  get blockedDateContainerTarget() {
    return $('[data-timesheets-config-form-target="blockedDateContainer"]')[0]
  }

  get blockedDateTemplateTarget() {
    return $('[data-timesheets-config-form-target="blockedDateTemplate"]')[0]
  }

  addBreak(event) {
    const day = event.target.dataset.day
    const container = this.breakContainerTargets.filter(`[data-day="${day}"]`)[0]

    if (!container) {
      console.error("Break container not found")
      return
    }

    const template = this.breakTemplateTarget && this.breakTemplateTarget.content.cloneNode(true)

    if (!template) {
      console.error("Break template not found")
      return
    }

    // Update the input names with the correct day
    // template.querySelectorAll("input").forEach(input => {
    //   const name = input.name.replace("DAY", day)
    //   input.name = name
    //   input.id = name
    // })

    // Replace DAY placeholders in input names
    template.querySelectorAll('[name*="DAY"]').forEach(element => {
      element.name = element.name.replace('DAY', day);
    });
    
    // Replace DAY_PLACEHOLDER in data-day attributes
    template.querySelectorAll('[data-day="DAY_PLACEHOLDER"]').forEach(element => {
      element.dataset.day = day;
    });

    // Hide the original button (the one outside the break rows container)
    // Only if this button is not inside a break row
    if (!event.target.closest('.break-row')) {
      event.target.style.display = 'none';
    }
    
    // Add the template to the container
    container.appendChild(template);
    
    // Initialize timepickers in the newly added row
    container.querySelectorAll('.timepicker:not(._air-datepicker-init)').forEach(el => {
      this.initTimepicker(el);
    });

    container.querySelectorAll('.start-timepicker:not(._air-datepicker-init)').forEach(el => {
      this.initTimepicker(el);
    });

    container.querySelectorAll('.end-timepicker:not(._air-datepicker-init)').forEach(el => {
      this.initTimepicker(el);
    });
  }

  removeBreak(event) {
    const breakRow = event.target.closest('.break-row');
    const container = breakRow.closest('[data-timesheets-config-form-target="breakContainer"]');
    const day = container.dataset.day;
    
    // Remove the break row
    breakRow.remove();
    
    // Check if there are remaining break rows
    const remainingBreakRows = container.querySelectorAll('.break-row');
    
    // If there are no more break rows, show the original "Add Break" button
    if (remainingBreakRows.length === 0) {
      // The original Add Break button is the next element after the container
      const originalAddButton = container.parentElement.querySelector(`[data-action="timesheets-config-form#addBreak"][data-day="${day}"]:not(.break-row button)`);
      if (originalAddButton) {
        originalAddButton.style.display = '';
      }
    }
  }

  addOvertimeRate() {
    const container = this.overtimeRateContainerTarget
    const template = this.overtimeRateTemplateTarget && this.overtimeRateTemplateTarget.content.cloneNode(true)

    if (!template) {
      console.error("Overtime rate template not found")
      return
    }

    container.appendChild(template)
  }

  removeOvertimeRate(event) {
    const rateElement = event.target.closest(".overtime-rate-row")
    if (rateElement) {
      rateElement.remove()
    }
  }

  addBlockedDate() {
    const container = this.blockedDateContainerTarget;
    const template = this.blockedDateTemplateTarget && this.blockedDateTemplateTarget.content.cloneNode(true);

    if (!template) {
      console.error("Blocked date template not found");
      return;
    }

    // Append the template to the container
    container.appendChild(template);

    // Initialize datepicker for the newly added input
    container.querySelectorAll('.datepicker:not(._air-datepicker-init)').forEach(el => {
      this.initDatepicker(el);
    });
  }

  removeBlockedDate(event) {
    const dateElement = event.target.closest(".blocked-date-row")
    if (dateElement) {
      dateElement.remove()
    }
  }

  removeWorkingHour(event) {
    const day = event.target.dataset.day;
    const row = this.element.querySelector(`.working-hour-row[data-day="${day}"]`);
  
    if (row) {
      const inputs = row.querySelectorAll('input');
      inputs.forEach(input => input.value = '');
    }
  }

  removeMandatoryHour(event) {
    const day = event.target.dataset.day;
    const row = this.element.querySelector(`.mandatory-hour-row[data-day="${day}"]`);
  
    if (row) {
      const inputs = row.querySelectorAll('input');
      inputs.forEach(input => input.value = '');
    }
  }
}
